export const EDUCATOR_ROLE_OPTIONS = [
  { value: 'shadow-teacher', label: 'Shadow Teacher' },
  { value: 'class-teacher', label: 'Class Teacher' },
  { value: 'special-educator', label: 'Special Educator' },
  { value: 'school-counselor', label: 'School Counselor' },
  { value: 'sport-coach', label: 'Sport Coach' },
];

const LEGACY_ROLE_MAP = {
  'Shadow Teacher (Discreet 1-on-1 support and help)': 'shadow-teacher',
  'Class Teacher (Classroom management & seat adjustments)': 'class-teacher',
  'Tuition Teacher (Private tutoring & homework help)': 'special-educator',
  'Sports Coach (Physical training & games on the field)': 'sport-coach',
  'Art/Music Teacher (Creative tasks, instruments & sensory tools)': 'school-counselor',
};

export function getEducatorRoleLabel(value) {
  return EDUCATOR_ROLE_OPTIONS.find((option) => option.value === value)?.label ?? 'Shadow Teacher';
}

export function normalizeEducatorRole(value) {
  return LEGACY_ROLE_MAP[value] || value || 'shadow-teacher';
}

export function createChildId(childName) {
  return String(childName || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .slice(0, 50);
}

export function createProductId(childId, educatorRole, legacyProfileId = '') {
  return legacyProfileId || `${childId}--${educatorRole}`;
}

export function splitChildBaselineAnswers(answers) {
  const next = { ...answers };
  delete next.educatorRole;
  delete next.role;
  return next;
}

export function mergeProductAnswers(childAnswers, productAnswers, educatorRole) {
  return {
    ...childAnswers,
    ...productAnswers,
    educatorRole,
  };
}
